import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import DotLoader from './DotLoader';

export default function ThinkingLoader() {
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowText(true), 5000);
    return () => clearTimeout(t);
  }, []);

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {showText && (
        <Typography variant="body2" color="text.secondary" fontSize="0.875rem">
          Thinking longer for a better answer
        </Typography>
      )}
      {/* 3 dots */}
      <DotLoader />
    </Box>
  );
}
